import { Record, List } from "immutable";
import { CIRCUIT_CATEGORY_LABELS } from "@infinode/constants/circuitCategories";

const CircuitCategoryRecord = Record({
  id: null,
  key: null,
  label: "",
  level: 0,
  hasSubLevel: false,
  children: List()
});

const createCircuitCategoryRecord = (categoryObj, level) => {
  return CircuitCategoryRecord({
    id: categoryObj.key,
    key: categoryObj.key,
    label: CIRCUIT_CATEGORY_LABELS[categoryObj.key],
    level: level,
    hasSubLevel: categoryObj.requireLevel2
  });
};

export { createCircuitCategoryRecord };

export default CircuitCategoryRecord;
